import { EnrichedCampaignSection, NewsletterSectionConfig } from '.';
import { emptySection } from '../utils/emptyTypes';

export const compareSectionAmount = (
  sections: EnrichedCampaignSection[],
  newsletterSectionConfig: NewsletterSectionConfig[],
) => {
  return newsletterSectionConfig.length - sections.length;
};

export const addOrRemoveSections = (
  enrichedSections: EnrichedCampaignSection[],
  sectionAmountDifference: number,
) => {
  let updatedEnrichedSections = [...enrichedSections];
  if (sectionAmountDifference > 0) {
    let i = sectionAmountDifference;
    // eslint-disable-next-line fp/no-loops
    while (i > 0) {
      updatedEnrichedSections = [
        ...updatedEnrichedSections,
        emptySection(updatedEnrichedSections.length + i),
      ];
      i--;
    }
  } else {
    // eslint-disable-next-line fp/no-mutating-methods
    updatedEnrichedSections.splice(
      updatedEnrichedSections.length + sectionAmountDifference,
    );
  }

  return updatedEnrichedSections;
};

export const buildSectionsDraftFromNewsletterConfig = (
  newsletterSectionConfig: NewsletterSectionConfig[],
) => {
  const sectionsDraft: EnrichedCampaignSection[] = [];
  let i = 0;
  // eslint-disable-next-line fp/no-loops
  while (i < newsletterSectionConfig.length) {
    // eslint-disable-next-line fp/no-mutating-methods
    sectionsDraft.push(
      emptySection(i + 1, newsletterSectionConfig[i].sectionResourceCount),
    );
    i++;
  }

  return sectionsDraft;
};
